export const parseCurrency = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const normalized = String(value).replace(/[$,\s]/g, "");
  const parsed = Number(normalized);

  return Number.isFinite(parsed) ? parsed : null;
};

export const formatCurrencyInput = (value) => {
  const normalized = String(value ?? "")
    .replace(/[^\d.]/g, "")
    .replace(/(\..*)\./g, "$1");

  if (!normalized) return "";

  const [integerPart, decimalPart] = normalized.split(".");
  const formattedInteger = integerPart
    ? Number(integerPart).toLocaleString("en-US")
    : "";

  if (decimalPart !== undefined) {
    return `${formattedInteger}.${decimalPart.slice(0, 2)}`;
  }

  return formattedInteger;
};

export const formatCurrencyDisplay = (value, fallback = "$0") => {
  const amount = parseCurrency(value);
  if (amount === null) return fallback;

  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
};
